<template>
    <div>
      <div v-if="loading">
        <v-progress-linear
          indeterminate
          color="primary"
          ></v-progress-linear>
      </div>
        <v-card>
            <v-card-title>Edit editorial</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-form ref="form" v-model="isValid">
                    <v-text-field
                        filled
                        label="Title"
                        :rules="validation.titleRules"
                        v-model="newsData.title"
                        @change="onTitleChange($event)"
                    ></v-text-field>
                    <redactor v-model="newsData.body"></redactor>
                    <br>
                    <v-text-field
                      label="Select publish date"
                      filled
                      clearable
                      readonly
                      :rules="validation.publishDateRules"
                      v-model="formattedDate"
                      @click:clear="dateClearCallback"
                      prepend-icon="mdi-calendar"
                      @click="showDatePicker"
                    ></v-text-field>
                </v-form>
            </v-card-text>
            <v-divider/>
            <v-card-actions>

                <v-btn
                    tile
                    color="primary"
                    class="mx-2"
                    v-on:click="update"
                    :disabled="!isValid"
                    v-bind:loading="loading"
                    >Update</v-btn
                >
                <v-spacer />
            </v-card-actions>
        </v-card>
        <DatePickerDialog @dateSelected="dateSelectionCallback" :visible="showDatePickerDialog" @close="showDatePickerDialog=false"></DatePickerDialog>

    </div>
</template>
<script>

import postApi from '@/api/postApi'
import snackbar from '@/utils/snackbar'
import * as dateFormats from '@/constants/dateFormats'
import dateUtils from '@/utils/dateUtils'
import DatePickerDialog from '@/components/DatePickerDialog'

import commonUtils from '@/utils/commonUtils'
import redactor from '@/components/Redactor.vue'

export default {
  components: {
    DatePickerDialog,
    redactor
  },
  mounted () {
    this.fetchEditorial()
  },
  data () {
    return {
      isValid: null,
      imageData: '',
      loading: false,
      formattedDate: null,
      showDatePickerDialog: false,
      validation: {
        publishDateRules: [(v) => !!v || 'Publish date is required'],
        titleRules: [(v) => !!v || 'Enter title']
      },
      newsData: {
        title: '',
        id: null,
        body: '',
        is_for_subscriber: null,
        publish_date: null

      }

    }
  },
  watch: {
    'newsData.title': function (newVal, oldVal) {
      this.$log.info('title ', [newVal, oldVal])
      if (newVal && newVal[newVal.length - 1] === '\\') {
        this.newsData.title = oldVal !== null ? oldVal + 'ṭ' : 'ṭ'
      } else if (newVal && newVal[newVal.length - 1] === '|') {
        this.newsData.title = oldVal !== null ? oldVal + 'Ṭ' : 'Ṭ'
      }
    }
  },
  computed: {

  },
  methods: {
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.newsData.publish_date = null
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.newsData.publish_date = dateUtils.parseDate(data)
    },
    showDatePicker () {
      this.showDatePickerDialog = true
    },
    async fetchEditorial () {
      this.loading = true
      try {
        const response = await postApi.getEditorialById(this.$route.params.id)
        this.$log.info(response.data)
        if (response.data !== undefined) {
          this.newsData.title = response.data.title
          this.newsData.body = response.data.body
          this.newsData.id = response.data.id
          this.newsData.publish_date = response.data.publish_date
          this.formattedDate = this.$moment(this.newsData.publish_date).format(dateFormats.DDMMYY)
        }
      } finally {
        this.loading = false
      }
    },
    async update () {
      this.loading = true
      try {
        if (this.newsData.body === '') {
          snackbar.show('Body is required', 'error')
          return
        }
        const response = await postApi.updateEditorial(this.newsData)
        this.$log.info(response.data)
        if (response.data !== undefined) {
          snackbar.show('Editorial added successfully', 'success')
          window.publish_date = this.newsData.publish_date
          this.$router.push({ path: '/editorial', replace: true })
        }
      } finally {
        this.loading = false
      }
    },
    onTitleChange (newVal, oldVal) {
      this.$log.info('Ontitle change', newVal, oldVal)
      this.newsData.title = commonUtils.parseStringForTri(newVal)
    }
  }
}
</script>

<style>
.ql-editor{
  min-height: 350px;
  font-size: 15px;
}
</style>
